import workImg from '../../../Assets/Images/workImg.jpg'
import icon1 from '../../../Assets/Images/Research.png';
import icon2 from '../../../Assets/Images/Solar.png';
import icon3 from '../../../Assets/Images/Planning.png';



const BoltIcon = () => (
  <svg className="w-3.5 h-3.5" fill="#4ade80" viewBox="0 0 24 24">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1C10.61 21 3 13.39 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.58a1 1 0 01-.25 1.01l-2.2 2.2z" />
    <path d="M15 2a9 9 0 019 9" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M15 6a5 5 0 015 5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const steps = [
  { id: "01", Icon: icon3 , title: "Project Planning", description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry." },
  { id: "02", Icon: icon1, title: "Research & Analysis", description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry." },
  { id: "03", Icon: icon2,  title: "Solar Installation",  description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry." },
];

// Dashed curved arrow SVG between steps
const DashedArrow = () => (
  <svg className="hidden lg:block flex-shrink-0" width="160" height="60" viewBox="0 0 160 60" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: "-40px" }}>
    <path
      d="M10 50 Q50 10 80 30 Q110 50 150 15"
      stroke="#4ade80"
      strokeWidth="3"
      strokeDasharray="6 5"
      strokeLinecap="round"
      fill="none"
    />
    <path d="M144 10 L152 16 L144 20" stroke="#4ade80" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export default function WorkProcess() {
  return (
    <div className="w-full bg-white" style={{ fontFamily: "'Barlow', 'Montserrat', sans-serif" }}>

      {/* ── Process Section ── */}
      <div className="px-6 md:px-10 lg:px-12 xl:px-20 py-16">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-1.5 mb-3">
            <BoltIcon />
            <span className="text-sm font-rajdhani font-bold tracking-[0.2em] uppercase" style={{ color: "#4ade80" }}>
              OUR LATEST PROCESS
            </span>
          </div>
          <h2
            className="font-bold text-[#1a2e0a] font-rajdhani text-2xl md:text-4xl lg:text-[45px] leading-relaxed "
            style={{ letterSpacing: "-0.02em" }}
          >
            Our Work Process
          </h2>
        </div>

        {/* Steps row */}
        <div className="flex flex-col md:flex-row items-start justify-center gap-0">
          {steps.map((step, i) => (
            <div key={step.id} className="flex flex-col lg:flex-row items-center flex-1">
              {/* Step card */}
              <div className="flex flex-col items-center text-center flex-1 px-6">
                {/* Icon box with number badge */}
                <div className="relative mb-6">
                  <div
                    className="flex items-center justify-center rounded-3xl p-6 bg-[#89EA5F]"
                  >
                    <img src={step.Icon} alt={step.title} className='size-16 object-cover ' />
                  </div>
                  {/* Number badge */}
                  <div
                    className="absolute -top-3 -right-3 w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-black border-2 border-white"
                    style={{ background: "#3dcc40", boxShadow: "0 2px 8px rgba(61,204,64,0.5)" }}
                  >
                    {step.id}
                  </div>
                </div>

                <h3 className="font-extrabold font-rajdhani text-gray-900 text-xl mb-3">{step.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{step.description}</p>
              </div>

              {/* Dashed arrow between steps */}
              {i < steps.length - 1 && <DashedArrow />}
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA Banner ── */}
      <div className="px-6 md:px-10 lg:px-12 xl:px-20 pb-16">
        <div
          className="relative flex items-center rounded-3xl overflow-hidden"
          style={{ background: "#e8f0e0", minHeight: "200px" }}
        >
          {/* Left image */}
          <div className="relative hidden lg:flex flex-shrink-0" style={{ width: "440px", height: "200px" }}>
            <img
              src={workImg}
              alt="Solar worker"
              className="w-full h-full object-cover"
              style={{ borderRadius: "0" }}
            />
            {/* Green phone button overlapping */}
            <div
              className="absolute -right-7 top-1/2 -translate-y-1/2 w-14 h-14 rounded-full flex items-center justify-center z-10"
              style={{
                background: "linear-gradient(135deg, #6ee85a 0%, #3dcc40 100%)",
                boxShadow: "0 4px 16px rgba(61,204,64,0.5)",
              }}
            >
              <PhoneIcon />
            </div>
          </div>

          {/* Right text */}
          <div className="flex-1 px-12 py-8">
            <h3
              className="font-black mb-3 text-xl sm:text-2xl lg:text-3xl"
              style={{ color: "#1a2e0a", letterSpacing: "-0.01em" }}
            >
              Have Questions?{" "}
              <span style={{ color: "#3dcc40" }}>Call Us</span>{" "}
              82496 75658
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" style={{ maxWidth: "560px" }}>
              It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}